import React from 'react';
import { Delete } from 'lucide-react';

export default function NumPad({ value, onChange, maxLength = 10, disabled = false, includeDecimal = false }) {
  const keys = includeDecimal
    ? ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', '⌫']
    : ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '⌫'];

  const handleKey = (key) => {
    if (disabled || key === '') return;
    if (key === '⌫') { onChange(value.slice(0, -1)); return; }
    if (key === '.' && value.includes('.')) return;
    const digitsOnly = value.replace('.', '');
    if (digitsOnly.length >= maxLength && key !== '.') return;
    onChange(value + key);
  };

  return (
    <div className="grid grid-cols-3 gap-3 w-full max-w-xs mx-auto">
      {keys.map((key, idx) => (
        <button
          key={idx}
          data-testid={`numpad-key-${key || 'empty'}`}
          onClick={() => handleKey(key)}
          disabled={disabled || key === ''}
          aria-label={key === '⌫' ? 'Cancella' : key}
          className={[
            'numpad-key h-14 rounded-full bg-[#222228] text-xl font-medium text-white',
            'hover:bg-[#2E2E36] transition-all duration-100 shadow-sm',
            'flex items-center justify-center select-none',
            key === '' ? 'opacity-0 pointer-events-none' : '',
            disabled ? 'opacity-40 cursor-not-allowed' : 'active:scale-90 active:bg-[#3A3A44]',
          ].join(' ')}
        >
          {key === '⌫' ? <Delete size={18} /> : key}
        </button>
      ))}
    </div>
  );
}
